import { AwsRumConfig } from 'aws-rum-web';

export type AwsRumEnvironments = 'local' | 'stage' | 'prod';
type AppConfig = {
    id: string;
    version: string;
    region: string;
};
export const getAwsRumConfig = (env: AwsRumEnvironments): { appConfig: AppConfig; awsRumConfig: AwsRumConfig } => {
    const local = {
        appConfig: {
            id: '9b3cce7b-1f40-4f24-b64e-9400488321a7',
            version: '1.0.0',
            region: 'us-east-1',
        },
        awsRumConfig: {
            sessionSampleRate: 1,
            guestRoleArn: 'arn:aws:iam::150977311597:role/RUM-Monitor-us-east-1-150977311597-1800230299071-Unauth',
            identityPoolId: 'us-east-1:e9fab633-c4a3-4f11-b969-b33cef264a05',
            endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
            telemetries: ['performance', 'errors', 'http'],
            allowCookies: true,
            enableXRay: false,
            pageIdFormat: 'PATH_AND_HASH',
        } as AwsRumConfig,
    };

    switch (env) {
        case 'local':
            return local;
        case 'stage':
            return {
                appConfig: {
                    id: '80e8d3a7-6ee2-4231-9398-88d15d2c7069',
                    version: '1.0.0',
                    region: 'us-east-1',
                },
                awsRumConfig: {
                    sessionSampleRate: 1,
                    guestRoleArn:
                        'arn:aws:iam::150977311597:role/RUM-Monitor-us-east-1-150977311597-5080180299071-Unauth',
                    identityPoolId: 'us-east-1:39475d1d-885c-4e0a-abde-fbf7de7fd745',
                    endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
                    telemetries: ['performance', 'errors', 'http'],
                    allowCookies: true,
                    enableXRay: false,
                    pageIdFormat: 'PATH_AND_HASH',
                },
            };
        case 'prod':
            return {
                appConfig: {
                    id: '31a62bbf-de93-4565-a5c2-283162024b4f',
                    version: '1.0.0',
                    region: 'us-east-1',
                },
                awsRumConfig: {
                    sessionSampleRate: 1,
                    guestRoleArn:
                        'arn:aws:iam::150977311597:role/RUM-Monitor-us-east-1-150977311597-7276780299071-Unauth',
                    identityPoolId: 'us-east-1:13267d52-0e1e-41c1-bde1-b40faf081676',
                    endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
                    telemetries: ['performance', 'errors', 'http'],
                    allowCookies: true,
                    enableXRay: false,
                    pageIdFormat: 'PATH_AND_HASH',
                },
            };
        default:
            return local;
    }
};
